import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';

const COLUMNS = ['Timestamp', 'Admin', 'Action', 'Target', 'Before', 'After', 'Reason'];

export default function Audit() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-semibold text-text-primary">Audit Log</h1>
        <p className="text-sm text-text-secondary mt-1">
          Append-only — every admin write recorded. Backend endpoint pending.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Admin actions</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-border bg-surface-elevated">
                  {COLUMNS.map((col) => (
                    <th
                      key={col}
                      className="px-4 py-2.5 text-left text-xs font-medium text-text-muted uppercase tracking-wide whitespace-nowrap"
                    >
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    colSpan={COLUMNS.length}
                    className="px-4 py-8 text-center text-sm text-text-muted italic"
                  >
                    No audit records — backend endpoint not yet deployed. Needs{' '}
                    <code className="font-mono text-xs bg-surface px-1 py-0.5 rounded">
                      GET /adm/audit?since=X&amp;admin=&amp;action=&amp;target=
                    </code>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
